<template>
  <div>
    <Breadcrumb :items="items" />
    <div class="position-relative">
      <div class="row">
        <!-- Left Sidebar: Drivers list -->
        <div class="col-md-3">
          <div>
            <p
              class="bg-main text-white p-2 d-flex align-items-center justify-content-between"
            >
              <span>السائقين</span>
              <i v-if="isFetching" class="fas fa-spinner fa-spin"></i>
            </p>

            <!-- Driver Search Input -->
            <div class="px-2 mb-2">
              <input
                v-model="searchKeyword"
                type="text"
                placeholder="بحث باسم السائق أو الهاتف..."
                class="form-control rounded-pill px-3 py-1.5"
                style="font-size: 13px; border: 1px solid #ced4da"
              />
            </div>

            <div class="btn-group w-100 mb-2" role="group">
              <button
                @click="driver_status = 'in_not_order'"
                type="button"
                :class="driver_status == 'in_not_order' && 'active'"
                class="btn btn-secondary rounded-0 flex-grow-1"
              >
                {{ $t("labels.free") }}
              </button>
              <button
                @click="driver_status = 'in_order'"
                type="button"
                :class="driver_status == 'in_order' && 'active'"
                class="btn btn-secondary rounded-0 flex-grow-1"
              >
                {{ $t("labels.busy") }}
              </button>
              <button
                @click="driver_status = 'not_available'"
                type="button"
                :class="driver_status == 'not_available' && 'active'"
                class="btn btn-secondary rounded-0 flex-grow-1"
              >
                {{ $t("labels.not_available") }}
              </button>
            </div>

            <div>
              <div
                v-for="user in markers"
                :key="user.id || user.driver_id"
                class="d-flex align-items-center justify-content-between gap-3 border-bottom py-2 cursor-pointer hover-item px-2"
                @click="selectDriver(user)"
              >
                <div
                  class="bg-main d-flex align-items-center justify-content-center text-white"
                  style="
                    width: 45px;
                    height: 45px;
                    object-fit: cover;
                    border-radius: 50%;
                  "
                >
                  {{ user?.orders_count }}
                </div>

                <div class="d-flex gap-2">
                  <div class="text-right">
                    <p class="mb-0 font-weight-bold" style="font-size: 14px">
                      {{ user?.full_name }}
                    </p>

                    <p class="mb-0 text-muted" style="font-size: 12px">
                      {{ user?.phone_complete_form }}
                    </p>
                  </div>

                  <div>
                    <img
                      :src="user?.image"
                      alt="Avatars"
                      style="
                        width: 45px;
                        height: 45px;
                        object-fit: cover;
                        border-radius: 50%;
                      "
                    />
                  </div>
                </div>
              </div>
            </div>

            <div
              v-if="user_meta"
              class="d-flex align-items-center justify-content-center"
            >
              <v-pagination
                :length="user_meta.last_page"
                :total-visible="10"
                v-model="page_user"
              ></v-pagination>
            </div>
          </div>
        </div>

        <!-- Middle: Google Map -->
        <div class="col-md-6">
          <div class="input_wrapper top_label mb-2">
            <input
              type="text"
              class="form-control"
              id="autocomplete"
              placeholder="ابحث على الخريطة"
              @click="initAutocomplete"
            />
          </div>
          <GmapMap
            v-if="center"
            style="width: 100%; height: 85vh"
            :center="center"
            :zoom="8"
            :draggable="true"
            map-type-id="terrain"
            :heading="90"
            :tilt="45"
            @click="handleMapClick"
          >
            <!-- Center Marker -->
            <GmapMarker
              :position="center"
              :draggable="true"
              @dragend="handleMarkerDrag"
            />

            <!-- Drivers Markers -->
            <div
              v-for="marker in markers"
              :key="`marker-${marker.id || marker.driver_id}`"
            >
              <GmapMarker
                :icon="image"
                :position="{
                  lat: parseFloat(marker.lat),
                  lng: parseFloat(marker.lng),
                }"
                @click="selectDriver(marker)"
              />
            </div>

            <!-- Orders Markers -->
            <template v-for="order in orders">
              <GmapMarker
                v-if="order.start_location"
                :key="`order-${order.id}`"
                :icon="orderPic"
                :position="{
                  lat: parseFloat(order.start_location.lat),
                  lng: parseFloat(order.start_location.lng),
                }"
                @click="goToOrderPage(order.id)"
              />
            </template>

            <!-- Driver Info Window -->
            <gmap-info-window
              :options="infoWindowOptions"
              :position="infoWindowPosition"
              :opened="infoWindowOpened"
              @closeclick="infoWindowOpened = false"
            >
              <div
                v-if="selectedDriver"
                dir="rtl"
                class="text-right p-2 info-window-popup"
                style="font-family: inherit; min-width: 200px"
              >
                <div
                  class="d-flex align-items-center gap-2 mb-2 pb-2 border-bottom"
                >
                  <img
                    :src="selectedDriver.image"
                    alt="Driver avatar"
                    style="
                      width: 40px;
                      height: 40px;
                      border-radius: 50%;
                      object-fit: cover;
                    "
                  />
                  <div>
                    <h6 class="mb-0 font-weight-bold">
                      <a
                        @click.prevent="
                          goToPartnerPage(
                            selectedDriver.id || selectedDriver.driver_id
                          )
                        "
                        href="#"
                        style="color: #783d73; text-decoration: underline"
                      >
                        {{ selectedDriver.full_name }}
                      </a>
                    </h6>
                    <small class="text-muted d-block">{{
                      selectedDriver.phone_complete_form
                    }}</small>
                  </div>
                </div>
                <div style="font-size: 13px">
                  <div v-if="selectedDriverActiveOrder" class="mb-1">
                    <span class="text-muted">الطلب النشط: </span>
                    <a
                      @click.prevent="
                        goToOrderPage(selectedDriverActiveOrder.id)
                      "
                      href="#"
                      class="font-weight-bold"
                      style="color: #783d73; text-decoration: underline"
                    >
                      #{{ selectedDriverActiveOrder.id }}
                    </a>
                  </div>
                  <div v-else class="text-muted mb-1">
                    لا يوجد طلب نشط حالياً
                  </div>
                  <div>
                    <span class="text-muted">إجمالي الطلبات: </span>
                    <span class="font-weight-bold text-dark">{{
                      selectedDriver.orders_count
                    }}</span>
                  </div>
                </div>
              </div>
            </gmap-info-window>
          </GmapMap>
        </div>

        <!-- Right Side: Orders OR Driver Details Sidebar -->
        <div class="col-md-3">
          <!-- Active Driver Details sidebar -->
          <div
            v-if="showDriverDetailsSidebar && selectedDriver"
            class="card shadow-sm border rounded p-3 h-100 bg-white driver-details-sidebar"
            dir="rtl"
          >
            <div
              class="d-flex align-items-center justify-content-between border-bottom pb-2 mb-3"
            >
              <h5 class="mb-0 font-weight-bold" style="color: #783d73">
                بيانات المندوب
              </h5>
              <button
                @click="showDriverDetailsSidebar = false"
                class="btn btn-sm btn-outline-secondary rounded-circle"
                style="width: 30px; height: 30px; padding: 0; line-height: 1"
              >
                &times;
              </button>
            </div>

            <div class="text-center mb-3">
              <img
                :src="selectedDriver.image"
                alt="Driver Image"
                class="rounded-circle border mb-2"
                style="width: 90px; height: 90px; object-fit: cover"
              />
              <h5 class="mb-1 font-weight-bold text-dark">
                {{ selectedDriver.full_name }}
              </h5>
              <span
                class="drawer-status-chip"
                :class="
                  realSelectedDriverStatus == 'in_not_order'
                    ? 'free-chip'
                    : realSelectedDriverStatus == 'in_order'
                    ? 'busy-chip'
                    : 'unavailable-chip'
                "
              >
                {{
                  realSelectedDriverStatus == "in_not_order"
                    ? "متاح"
                    : realSelectedDriverStatus == "in_order"
                    ? "مشغول"
                    : "غير متاح"
                }}
              </span>
            </div>

            <div class="details-list mb-4 text-right">
              <div class="d-flex justify-content-between py-2 border-bottom">
                <span class="text-muted">الهاتف:</span>
                <span class="font-weight-bold text-dark" dir="ltr">{{
                  selectedDriver.phone_complete_form
                }}</span>
              </div>
              <div
                class="d-flex justify-content-between py-2 border-bottom"
                v-if="selectedDriver.id_number"
              >
                <span class="text-muted">رقم الهوية:</span>
                <span class="font-weight-bold text-dark">{{
                  selectedDriver.id_number
                }}</span>
              </div>
              <div
                class="d-flex justify-content-between py-2 border-bottom"
                v-if="selectedDriver.nationality"
              >
                <span class="text-muted">الجنسية:</span>
                <span class="font-weight-bold text-dark">{{
                  selectedDriver.nationality
                }}</span>
              </div>
              <div class="d-flex justify-content-between py-2 border-bottom">
                <span class="text-muted">الطلب النشط:</span>
                <span v-if="selectedDriverActiveOrder" class="font-weight-bold">
                  <a
                    @click.prevent="goToOrderPage(selectedDriverActiveOrder.id)"
                    href="#"
                    style="color: #783d73; text-decoration: underline"
                  >
                    #{{ selectedDriverActiveOrder.id }}
                  </a>
                </span>
                <span v-else class="text-muted">لا يوجد</span>
              </div>
              <div class="d-flex justify-content-between py-2 border-bottom">
                <span class="text-muted">إجمالي الطلبات:</span>
                <span class="font-weight-bold text-dark">{{
                  selectedDriver.orders_count
                }}</span>
              </div>
            </div>

            <!-- Action buttons as requested -->
            <div class="d-flex flex-column gap-2 mt-auto">
              <!-- <v-btn
                color="#783d73"
                class="text-white w-100 mb-2"
                depressed
                @click="goToDeliveryOrdersList"
              >
                <i class="fal fa-list-ul ml-2"></i>
                صفحة طلبات التوصيل
              </v-btn> -->

              <v-btn
                color="#783d73"
                class="text-white w-100 mb-2"
                depressed
                @click="
                  goToDriverDeliveryOrders(
                    selectedDriver.id || selectedDriver.driver_id
                  )
                "
              >
                <i class="fal fa-truck ml-2"></i>
                طلبات التوصيل للسائق
              </v-btn>

              <v-btn
                color="#783d73"
                class="text-white w-100"
                depressed
                @click="
                  goToDriverPackageOrders(
                    selectedDriver.id || selectedDriver.driver_id
                  )
                "
              >
                <i class="fal fa-box ml-2"></i>
                صفحة طرود السائق
              </v-btn>
            </div>
          </div>

          <!-- Default: Orders List -->
          <div v-else>
            <p
              class="bg-main text-white p-2 d-flex align-items-center justify-content-between"
            >
              <span>الأوردرات</span>
              <i v-if="isFetching" class="fas fa-spinner fa-spin"></i>
            </p>

            <!-- Order Search Input -->
            <div class="px-2 mb-2">
              <input
                v-model="searchOrderId"
                type="text"
                placeholder="بحث برقم الطلب..."
                class="form-control rounded-pill px-3 py-1.5"
                style="font-size: 13px; border: 1px solid #ced4da"
              />
            </div>

            <div class="btn-group w-100 mb-2" role="group">
              <button
                @click="order_status = 'finished'"
                type="button"
                :class="order_status == 'finished' && 'active'"
                class="btn btn-secondary rounded-0 flex-grow-1"
              >
                {{ $t("labels.finished") }}
              </button>
              <button
                @click="order_status = 'driver_assign'"
                type="button"
                :class="order_status == 'driver_assign' && 'active'"
                class="btn btn-secondary rounded-0 flex-grow-1"
              >
                {{ $t("labels.driver_assign") }}
              </button>
              <button
                @click="order_status = 'pending'"
                type="button"
                :class="order_status == 'pending' && 'active'"
                class="btn btn-secondary rounded-0 flex-grow-1"
              >
                {{ $t("labels.pending") }}
              </button>
            </div>

            <div>
              <div
                v-for="order in orders"
                :key="order.id"
                class="d-flex align-items-center justify-content-end gap-3 border-bottom py-2 cursor-pointer"
                @click="goToOrderPage(order.id)"
              >
                <div dir="ltr">
                  <p
                    class="mb-2 text-truncate"
                    style="font-size: 14px; max-width: 300px"
                    :title="order.start_location?.location"
                  >
                    <span
                      class="d-block bg-main text-white"
                      style="width: fit-content"
                      >start location</span
                    >
                    {{ order.start_location?.location || "—" }}
                  </p>

                  <p
                    class="mb-0 text-truncate"
                    style="font-size: 14px; max-width: 250px"
                    :title="order.end_location?.location"
                  >
                    <span
                      class="d-block bg-main text-white"
                      style="width: fit-content"
                      >end location</span
                    >
                    {{ order.end_location?.location || "—" }}
                  </p>
                </div>

                <div>
                  <img
                    :src="order.client?.avatar"
                    alt="Avatars"
                    style="
                      width: 60px;
                      height: 60px;
                      object-fit: cover;
                      border-radius: 50%;
                    "
                  />
                </div>
              </div>
            </div>

            <div
              v-if="order_meta"
              class="d-flex align-items-center justify-content-center"
            >
              <v-pagination
                :length="order_meta.last_page"
                :total-visible="10"
                v-model="page_order"
              ></v-pagination>
            </div>
          </div>
        </div>
      </div>

      <!-- <div id="mapCanvas" style="width: 100%; height: 85vh;"> -->
      <!-- </div> -->
      <div class="load_drivers fadeIn" v-if="showLoad">
        <div class="floating-button">
          <i class="fas fa-hourglass-start"></i>
        </div>
        <div class="text">{{ $t("labels.searchDrivers") }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import GmapCustomMarker from "vue2-gmap-custom-marker";
import sportCarImage from "@/assets/images/sport-car.png";
import orderImage from "@/assets/images/order.png";
import io from "socket.io-client";

export default {
  // components: { "gmap-custom-marker": GmapCustomMarker },

  data() {
    return {
      order_status: "finished",
      driver_status: "in_not_order",
      page_order: 1,
      order_meta: null,
      page_user: 1,
      user_meta: null,
      showLoad: false,
      isFetching: false,
      hasLoadedOnce: false,
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.drivers.title"),
          disabled: false,
          href: "/driver/show-all",
        },
        {
          text: this.$t(`breadcrumb.drivers.drivers_tracking`),
          disabled: true,
          href: "",
        },
      ],
      image: {
        url: sportCarImage,
        size: { width: 32, height: 32 },
      },
      orderPic: {
        url: orderImage,
        size: { width: 32, height: 32 },
      },
      center: null,
      clickedLatLng: null,
      markers: [],
      orders: [],
      country_id: null,
      previous_country_id: null,

      // Driver tracking state properties
      searchKeyword: "",
      searchOrderId: "",
      searchTimeout: null,
      selectedDriver: null,
      showDriverDetailsSidebar: false,
      infoWindowPosition: null,
      infoWindowOpened: false,
      infoWindowOptions: {
        pixelOffset: { width: 0, height: -35 },
      },
    };
  },

  computed: {
    selectedDriverActiveOrder() {
      if (!this.selectedDriver) return null;
      const driver = this.selectedDriver;
      const driverId = driver.id || driver.driver_id;

      // 1. Search in orders list first
      let activeOrder = this.orders.find(
        (order) =>
          (order.driver && order.driver.id == driverId) ||
          order.driver_id == driverId
      );

      // 2. Fallback to order_id/active_order_id, or the raw order object on the driver
      if (!activeOrder) {
        const orderSource =
          driver.active_order_id ||
          driver.order_id ||
          driver.active_order ||
          driver.order;
        if (orderSource && typeof orderSource === "object") {
          activeOrder = orderSource;
        } else if (orderSource) {
          activeOrder = { id: orderSource };
        }
      }
      return activeOrder || null;
    },
    realSelectedDriverStatus() {
      if (!this.selectedDriver) return "in_not_order";
      const driver = this.selectedDriver;
      const status =
        driver.current_status || driver.status || driver.driver_status;
      if (
        status === "in_order" ||
        status === "in_not_order" ||
        status === "not_available"
      ) {
        return status;
      }
      if (this.selectedDriverActiveOrder && this.selectedDriverActiveOrder.id) {
        return "in_order";
      }
      if (driver.is_not_available || driver.is_active === 0) {
        return "not_available";
      }
      return "in_not_order";
    },
  },

  methods: {
    selectDriver(driver) {
      this.selectedDriver = driver;
      this.infoWindowPosition = {
        lat: parseFloat(driver.lat),
        lng: parseFloat(driver.lng),
      };
      this.infoWindowOpened = true;
      this.center = {
        lat: parseFloat(driver.lat),
        lng: parseFloat(driver.lng),
      };
      this.showDriverDetailsSidebar = true;
    },

    goToDeliveryOrdersList() {
      let route = this.$router.resolve({ path: "/delivery_orders/show-all" });
      window.open(route.href, "_blank");
    },
    goToDriverDeliveryOrders(driverId) {
      let route = this.$router.resolve({
        path: `/driver/show/${driverId}/deliveryOrders`,
      });
      window.open(route.href, "_blank");
    },
    goToDriverPackageOrders(driverId) {
      let route = this.$router.resolve({
        path: `/driver/show/${driverId}/packageOrders`,
      });
      window.open(route.href, "_blank");
    },

    handleMapClick(event) {
      this.center = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
      this.clickedLatLng = this.center;
      console.log("[Map] Clicked on:", this.clickedLatLng);
      this.trackingOrder(this.center.lat, this.center.lng);
    },

    initAutocomplete() {
      const input = document.getElementById("autocomplete");
      if (!input) return;
      const searchBox = new google.maps.places.SearchBox(input);
      searchBox.addListener("places_changed", () => {
        const places = searchBox.getPlaces();
        if (places.length === 0) return;
        const place = places[0];
        if (!place.geometry || !place.geometry.location) return;

        this.center = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng(),
        };
        this.clickedLatLng = this.center;
        this.trackingOrder(this.center.lat, this.center.lng);
      });
    },

    handleMarkerDrag(event) {
      this.center = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng(),
      };
      this.clickedLatLng = this.center;
      console.log("[Map] Dragged to:", this.clickedLatLng);
      this.trackingOrder(this.center.lat, this.center.lng);
    },

    getLocation() {
      const _self = this;
      let lat = 24.7136;
      let lng = 46.7385;

      const countryData = localStorage.getItem("zoz_dash_country");
      if (countryData) {
        try {
          const parsedCountry = JSON.parse(countryData);
          if (parsedCountry) {
            if (
              parsedCountry.key === "EG" ||
              (parsedCountry.name &&
                (parsedCountry.name.includes("مصر") ||
                  parsedCountry.name.toLowerCase().includes("egypt")))
            ) {
              lat = 30.0444;
              lng = 31.2357;
            } else if (
              parsedCountry.key === "SA" ||
              (parsedCountry.name &&
                (parsedCountry.name.includes("السعودية") ||
                  parsedCountry.name.toLowerCase().includes("saudi")))
            ) {
              lat = 24.7136;
              lng = 46.7385;
            }
          }
        } catch (e) {
          console.error("Error parsing country from localStorage:", e);
        }
      }

      _self.center = {
        lat: lat,
        lng: lng,
      };
      _self.clickedLatLng = {
        lat: lat,
        lng: lng,
      };
      this.trackingOrder(_self.center.lat, _self.center.lng);
    },

    /**
     * Fetch all drivers/orders for the given coordinates.
     * Includes the searchKeyword parameter for driver name or phone query.
     */
    trackingOrder(lat, lng) {
      // Clear stale area data so markers from the old area never bleed in
      this.markers = [];
      this.orders = [];
      this.isFetching = true;
      // Only block the whole screen on the very first load; later refreshes
      // (search, filters, pagination) use the small inline spinner instead.
      this.showLoad = !this.hasLoadedOnce;

      const countryData = localStorage.getItem("zoz_dash_country");
      let countryId = null;
      if (countryData) {
        try {
          const parsedCountry = JSON.parse(countryData);
          if (parsedCountry) {
            countryId = parsedCountry.id;
          }
        } catch (e) {
          console.error("Error parsing country from localStorage:", e);
        }
      }

      this.$axios({
        method: "GET",
        url: `track/orders`,
        params: {
          lat: lat,
          lng: lng,
          country_id: countryId || undefined,
          order_status: this.order_status,
          driver_status: this.driver_status,
          page_order: this.page_order,
          page_user: this.page_user,
          keyword: this.searchKeyword || undefined,
          order_id: this.searchOrderId || undefined,
        },
      })
        .then((res) => {
          // Save the OLD country_id BEFORE overwriting — mapLogic() needs it
          // to remove the previous socket listener without leaving orphans.
          this.previous_country_id = this.country_id;

          this.country_id = res.data.country_id || res.data.data?.country_id || countryId;
          const rawUsers = res.data.data.users ?? [];
          this.markers = rawUsers.map((u) => ({
            ...u,
            current_status: u.status || u.driver_status || this.driver_status,
          }));
          this.orders = res.data.data.orders ?? [];
          this.order_meta = res.data.order_meta;
          this.user_meta = res.data.user_meta;

          console.log("[API] country_id returned:", this.country_id);
          console.log("[API] Drivers returned:", this.markers.length);
          console.log("[API] Orders returned:", this.orders.length);
          console.log(
            "[API] Driver IDs on map:",
            this.markers.map((m) => m.driver_id ?? m.id)
          );

          this.mapLogic();
        })
        .catch((err) => {
          console.error("[API] trackingOrder error:", err);
        })
        .finally(() => {
          this.isFetching = false;
          this.showLoad = false;
          this.hasLoadedOnce = true;
        });
    },

    setOrder(order) {
      if (!this.orders.find((el) => el.id == order.id)) {
        this.orders.push(order);
      }
    },

    removeOrder(orderId) {
      this.orders = this.orders.filter((el) => el.id != orderId);
    },

    /**
     * Handles the data payload from the track-order:{geo_code} socket event.
     * Extracted into its own method so mapLogic() stays readable.
     *
     * Responsibilities:
     *  - Subscribe each driver in the area to live location updates.
     *  - Add / update / remove orders based on their current status.
     */
    handleTrackOrderEvent(data) {
      // Subscribe to per-driver location rooms for all drivers in this area
      if (data.users && data.users.length > 0) {
        data.users.forEach((el) => {
          this.socket.emit("join_update_location", {
            driver_id: el.id,
            dashboard: true,
          });
        });
      }

      // Process order state changes
      if (data.order) {
        const status = data.order.status;
        let shouldShow = false;

        if (this.order_status === "pending") {
          shouldShow = [
            "pending",
            "restaurant_accept",
            "restaurant_ready",
          ].includes(status);
        } else if (this.order_status === "driver_assign") {
          shouldShow = [
            "driver_accept",
            "driver_start_order",
            "driver_pre_finished",
            "driver_received",
          ].includes(status);
        } else if (this.order_status === "finished") {
          shouldShow = [
            "driver_finished_package",
            "driver_finished_delivery",
          ].includes(status);
        }

        // Force-remove cancelled orders regardless of active filter
        if (
          ["admin_cancel", "client_cancel", "restaurant_cancel"].includes(
            status
          )
        ) {
          shouldShow = false;
        }

        const foundIndex = this.orders.findIndex(
          (el) => el.id == data.order.id
        );

        if (shouldShow) {
          if (foundIndex !== -1) {
            this.$set(this.orders, foundIndex, data.order);
          } else {
            this.setOrder(data.order);
          }
        } else {
          if (foundIndex !== -1) {
            this.removeOrder(data.order.id);
          }
        }
      }
    },

    /**
     * Attaches socket listeners scoped to the current geo_code area.
     *
     * Root-cause fixes applied here:
     *
     * 1. RACE CONDITION (original bug):
     *    getLocation() was called before the socket connected, so this
     *    method returned early on every initial load. Fixed by only calling
     *    getLocation() inside the socket "connect" callback in created().
     *
     * 2. DUPLICATE LISTENERS (original bug):
     *    previous_geo_code was set inside the track-order callback, so the
     *    old room's listener was never removed before attaching a new one.
     *    Fixed by saving previous_geo_code in trackingOrder() before calling
     *    this method.
     *
     * 3. CROSS-AREA DRIVER LEAKAGE (primary bug):
     *    update_location and update_location_on_map are global broadcasts —
     *    every driver's movement fires them on every connected client.
     *    Fixed with a two-layer area safety filter:
     *      Layer 1 — if the backend includes geo_code in the payload, compare
     *                it directly and discard mismatches.
     *      Layer 2 — if the backend does NOT include geo_code, only accept
     *                drivers already present in the initial API result for
     *                this area (checked via driver_id in this.markers).
     */
    mapLogic() {
      const socket = this.socket;

      if (!socket || !socket.connected) {
        console.warn(
          "[Socket] mapLogic called but socket is not connected yet — skipping."
        );
        return;
      }

      // ── 1. Remove the previous country_id room listener (prevents duplicates)
      if (this.previous_country_id && this.previous_country_id !== this.country_id) {
        socket.off(`track-order:${this.previous_country_id}`);
        console.log(
          "[Socket] Removed old room listener:",
          `track-order:${this.previous_country_id}`
        );
      }

      // ── 2. Remove global listeners before re-registering with country filter
      socket.off("update_location");
      socket.off("update_location_on_map");
      socket.off("driver_location_update");

      if (!this.country_id) {
        console.warn("[Socket] No country_id — skipping room join.");
        return;
      }

      console.log(
        "[Socket] Joining room:",
        `track-order:${this.country_id}`,
        "| Socket ID:",
        socket.id
      );

      // ── 3. Country-scoped track-order listener (orders + driver subscriptions)
      socket.on(`track-order:${this.country_id}`, (data) => {
        console.log("[Socket] track-order event received:", data);

        // Safety filter: discard events that carry a mismatched country_id
        if (data.country_id && data.country_id !== this.country_id) {
          console.warn(
            "[Socket] track-order discarded — wrong country_id:",
            data.country_id
          );
          return;
        }

        this.handleTrackOrderEvent(data);
      });

      const handleLocationUpdate = (data, isMapUpdate = false) => {
        if (!data) return;

        const driverId = data.driver_id;
        const payloadCountryId = data.country_id;

        // Layer 1: Compare country_id if provided
        
        if (payloadCountryId) {
          if (payloadCountryId !== this.country_id) {
            console.warn(
              `[Socket] location update discarded — wrong country_id: ${payloadCountryId} (expected: ${this.country_id})`
            );
            this.removeMarker(driverId);
            return;
          }
        }

        // Layer 2: Fallback to existing marker check if no country_id is provided
        if (!payloadCountryId) {
          const driverInArea = this.markers.some(
            (m) => (m.driver_id ?? m.id) === driverId
          );
          if (!driverInArea) {
            console.warn(
              `[Socket] location update discarded — driver ${driverId} not in current country`
            );
            return;
          }
        }

        // Re-subscribe to driver location room
        if (!isMapUpdate) {
          socket.emit("join_update_location", {
            driver_id: driverId,
            dashboard: true,
          });
        }

        // Compare status if status is provided in data, otherwise assume same status
        const statusToCompare = data.status !== undefined ? data.status : this.driver_status;
        if (statusToCompare === this.driver_status) {
          this.setMarker(data);
        } else {
          this.removeMarker(driverId);
        }
      };

      // ── 4. Live driver position updates
      socket.on("update_location", (data) => handleLocationUpdate(data, false));
      socket.on("driver_location_update", (data) => handleLocationUpdate(data, false));

      // ── 5. Map-position updates
      socket.on("update_location_on_map", (data) => handleLocationUpdate(data, true));
    },

    /**
     * Upserts a driver marker by driver_id.
     * Works with API responses that use either { driver_id } or { id } shapes.
     */
    setMarker(data) {
      const foundIdx = this.markers.findIndex(
        (el) => (el.driver_id ?? el.id) === data.driver_id
      );

      const parsedLat = parseFloat(data.lat);
      const parsedLng = parseFloat(data.lng);

      if (foundIdx !== -1) {
        const updatedDriver = {
          ...this.markers[foundIdx],
          ...data,
          current_status: data.status || data.driver_status || this.markers[foundIdx].current_status || this.driver_status,
          lat: parsedLat,
          lng: parsedLng,
        };
        this.$set(this.markers, foundIdx, updatedDriver);

        // Also update info window position if this driver is currently active and selected
        if (this.selectedDriver && (this.selectedDriver.id == data.driver_id || this.selectedDriver.driver_id == data.driver_id)) {
          this.infoWindowPosition = {
            lat: parsedLat,
            lng: parsedLng,
          };
          this.selectedDriver = updatedDriver;
        }
      } else {
        this.markers.push({
          ...data,
          lat: parsedLat,
          lng: parsedLng,
          id: data.driver_id,
        });
      }

      console.log(
        "[Map] setMarker — driver_id:",
        data.driver_id,
        "| Total on map:",
        this.markers.length,
        "| IDs:",
        this.markers.map((m) => m.driver_id ?? m.id)
      );
    },

    removeMarker(markerId) {
      console.log("[Map] removeMarker — driver_id:", markerId);
      this.markers = this.markers.filter(
        (el) => (el.driver_id ?? el.id) !== markerId
      );
    },

    goToPartnerPage(e) {
      let route = this.$router.resolve({ path: `/driver/show/${e}` });
      window.open(route.href, "_blank");
    },

    goToOrderPage(e) {
      let route = "";
      let obj = this.orders.find((el) => el.id == e);
      if (obj?.order_type == "package") {
        route = this.$router.resolve({ path: `/package_order/show/${e}` });
      } else {
        route = this.$router.resolve({ path: `/delivery_orders/show/${e}` });
      }
      window.open(route.href, "_blank");
    },
  },

  async created() {
    this.control = this.$permission.setControls(this.$route.path);

    // Create the socket connection FIRST, then load initial area data inside the
    // "connect" callback. This eliminates the original race condition where
    // getLocation() → trackingOrder() → mapLogic() ran synchronously before the
    // socket handshake finished, causing mapLogic() to hit the
    // `if (!socket.connected) return` guard and never attach any listeners.
    this.socket = io(`${process.env.VUE_APP_BASE_URL_SOCKET}:3073`);

    this.socket.on("connect", () => {
      console.log("[Socket] Connected — ID:", this.socket.id);
      // Trigger the initial area fetch only once the socket is confirmed ready
      if (!this.country_id) {
        this.getLocation();
      }
    });

    this.socket.on("disconnect", (reason) => {
      console.warn("[Socket] Disconnected:", reason);
    });

    this.socket.on("connect_error", (err) => {
      console.error("[Socket] Connection error:", err.message);
    });
  },

  beforeDestroy() {
    if (this.socket) {
      // Remove all registered listeners before disconnecting to avoid memory leaks
      if (this.country_id) {
        this.socket.off(`track-order:${this.country_id}`);
      }
      if (this.previous_country_id && this.previous_country_id !== this.country_id) {
        this.socket.off(`track-order:${this.previous_country_id}`);
      }
      this.socket.off("update_location");
      this.socket.off("update_location_on_map");
      this.socket.off("driver_location_update");
      this.socket.disconnect();
      this.socket = null;
      console.log("[Socket] Disconnected and all listeners cleaned up.");
    }
  },

  watch: {
    searchKeyword: {
      handler() {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }
        this.searchTimeout = setTimeout(() => {
          if (this.clickedLatLng) {
            this.trackingOrder(this.clickedLatLng.lat, this.clickedLatLng.lng);
          } else {
            this.getLocation();
          }
        }, 500);
      },
    },
    searchOrderId: {
      handler() {
        if (this.searchTimeout) {
          clearTimeout(this.searchTimeout);
        }
        this.searchTimeout = setTimeout(() => {
          if (this.clickedLatLng) {
            this.trackingOrder(this.clickedLatLng.lat, this.clickedLatLng.lng);
          } else {
            this.getLocation();
          }
        }, 500);
      },
    },
    driver_status: {
      handler() {
        if (!this.clickedLatLng) return;
        this.trackingOrder(this.clickedLatLng.lat, this.clickedLatLng.lng);
      },
      deep: true,
    },
    order_status: {
      handler() {
        if (!this.clickedLatLng) return;
        this.trackingOrder(this.clickedLatLng.lat, this.clickedLatLng.lng);
      },
      deep: true,
    },
    page_order: {
      handler() {
        if (!this.clickedLatLng) return;
        this.trackingOrder(this.clickedLatLng.lat, this.clickedLatLng.lng);
      },
      deep: true,
    },
    page_user: {
      handler() {
        if (!this.clickedLatLng) return;
        this.trackingOrder(this.clickedLatLng.lat, this.clickedLatLng.lng);
      },
      deep: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.showDetails {
  margin: 0 26px 0 0;
  a {
    color: var(--main);
    font-size: 13px;
    text-decoration: underline !important;
  }
}
.load_drivers {
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: rgba(9, 9, 9, 0.6);
  top: 0;
  left: 0;
  @include flexCenterAlignment;
  flex-direction: column;
  .text {
    position: relative;
    color: #fff;
    border-radius: 50px;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 23px;
    cursor: pointer;
    z-index: 99;
  }
}
.bg-main {
  background-color: #783d73;
}

.input_wrapper {
  margin-block: 0 !important;
  &.top_label {
    margin-bottom: 7px !important;
  }
}

.hover-item {
  transition: background-color 0.2s ease-in-out;
  &:hover {
    background-color: rgba(120, 61, 115, 0.08);
  }
}

.driver-details-sidebar {
  animation: slideIn 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateX(20px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
}

.info-window-popup {
  a:hover {
    color: darken(#783d73, 15%) !important;
  }
}

.drawer-status-chip {
  display: inline-block;
  padding: 4px 14px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: bold;
}
.free-chip {
  background: #ccf2e4;
  color: #16c182;
}
.busy-chip {
  background: #f3dcff;
  color: #a900ff;
}
.unavailable-chip {
  background: #ffdee8;
  color: #ff2366;
}
</style>
